const APP_NAME = "ColumnExtract"
const ROUTE_PREFIX = "/pwa-column-extract"


export {APP_NAME, ROUTE_PREFIX};